import { useUserStore, hasOrgPermission } from "@/stores/user";
import type { MiddlewareContext } from "@/types";

// Redirect to an error page if trying to get to the licenses page without proper permissions
export const blockLicenses = ({ next, router }: MiddlewareContext) => {
  const store = useUserStore();

  const blockLicenses =
    !hasOrgPermission(store, "change_group") ||
    !store.user?.current_org?.has_descendent_organizations ||
    store.user?.current_org?.can_accept_license;

  if (blockLicenses) {
    router.push({
      name: "Error"
    });
    return;
  }

  return next();
};
